import React, { useEffect, useState } from "react";
import { Col_12_8_6_4 } from "../../../../components/col/Col_12_8_6_4";
import LabelValor from "../../../../components/label/LabelValor";
import { Alert, Modal, Space } from "antd";
import LabelText from "../../../../components/input/LabelText";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { startUpdateServicio } from "../../../../context/actions/concesionariosActions";

///
export const SigsaId = () => {
  const { id } = useParams();
  const [valorId, setValorId] = useState();
  const dispatch = useDispatch();

  const { concesionariosServicio: c } = useSelector(
    (state) => state.concesionariosReducer
  );

  const [openSigsaIdModal, setOpenSigsaIdModal] = useState(false);

  const handleOkSigsaIdModal = () => {
    dispatch(startUpdateServicio({ sigsaId: valorId }, id));
    setOpenSigsaIdModal(false);
  };

  useEffect(() => {
    setValorId(c.sigsaId);
  }, [c.sigsaId]);
  ////
  return (
    <>
      <Col_12_8_6_4>
        <LabelValor
          labelStyle={{ cursor: "pointer", textDecoration: "underline dotted" }}
          onClick={() => setOpenSigsaIdModal(true)}
          label="ID Sigsa"
          valor={c.sigsaId}
        />
      </Col_12_8_6_4>
      <Modal
        title="Actualizar ID Sigsa"
        onCancel={() => setOpenSigsaIdModal(false)}
        onOk={handleOkSigsaIdModal}
        open={openSigsaIdModal}
        okText="Guardar"
        cancelText="Cancelar"
      >
        <Space direction="vertical">
          <Alert
            banner
            showIcon
            type="warning"
            message={
              <small>
                Al enviar o actualizar el ID Sigsa, se actualizará el COSTO
                TOPE en la OP de SIGSA.
              </small>
            }
          />
          <LabelText
            onChange={({ target }) => setValorId(target.value)}
            label="ID Sigsa"
            value={valorId}
          />
        </Space>
      </Modal>
    </>
  );
};
